// extracted by mini-css-extract-plugin
export default {"list":"_3Vb63Bci","break":"_1je47aeP","placeholder":"_1_7oG-Eo","compactMode":"zJkt532U","beefyMode":"_3_7EWvKi","listMode":"_17FtnR-v","squeeze":"_3E5x5m9M"};